module.exports = __webpack_public_path__ + "img/zd-up-4.c0bb6776.svg";